import React from 'react';
import { Box, HStack, Text } from '@skin-seoul/design-system';
interface RatingData {
  key: string;
  value: number;
  color: string;
  textColor: string;
  label: string;
}
interface BarChartProps {
  ratings: RatingData[];
}
const BarChart = ({
  ratings
}: BarChartProps) => {
  const MIN_PERCENT = 5;
  const total = ratings.reduce((sum, rating) => sum + rating.value, 0);
  if (total === 0) {
    return null;
  }
  const nonZeroCount = ratings.filter(r => r.value > 0).length;
  const leftover = 100 - nonZeroCount * MIN_PERCENT;
  const percentages = ratings.map(rating => rating.value === 0 ? {
    ...rating,
    percentage: 0
  } : {
    ...rating,
    percentage: MIN_PERCENT + rating.value / total * leftover
  });
  const getGradient = (key: string) => {
    switch (key) {
      case 'great':
        return 'linear-gradient(to left, #3d1690 71.918%, #12062a 160%)';
      case 'good':
        return 'linear-gradient(to right, #652be0, #976df3)';
      case 'acceptable':
        return 'linear-gradient(to left, #ff6467, #976df3)';
      case 'sensitive':
        return '#ff6467';
      default:
        return 'primary.400';
    }
  };
  return <Box position="relative" width="100%" height="24px" borderRadius="7px" overflow="hidden" data-sentry-element="Box" data-sentry-component="BarChart" data-sentry-source-file="BarChart.tsx">
      {/* Bar segments */}
      <HStack width="100%" height="100%" gap={0.5} data-sentry-element="HStack" data-sentry-source-file="BarChart.tsx">
        {percentages.map(rating => rating.value > 0 && <Box key={rating.key} background={getGradient(rating.key)} height="100%" width={`${rating.percentage}%`} flexShrink={0} display="flex" alignItems="center" borderRadius="4px">
                <Text textStyle={{
          base: 'label.small',
          tablet: 'label.medium'
        }} fontWeight="medium" color="white" marginLeft={2}>
                  {rating.value}
                </Text>
              </Box>)}
      </HStack>
    </Box>;
};
export default BarChart;